<template>
  <div>
    <div class="p-3">
      <div class="breadcrumb-area pos-relative w-100">
        <h1>Cập nhật thông tin tài khoản đối tác</h1>
        <div class="btn-group float-right">
          <button
            type="button"
            class="font-medium btn btn-outline-secondary"
            @click="$router.push(`/list-agent-partner-detail/${entryId}`)"
          >
            <i class="bx bx-arrow-back"></i> Quay lại
          </button>
          <button class="btn font-medium btn-primary" @click="saveData">
            <i class="bx bx-save"></i><span>&nbsp;</span>Lưu
          </button>
        </div>
      </div>
      <div class="p-10 pt-15 b-t-1-869fb229">
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-detail card p-4">
              <div class="form-group form-row">
                <label for="contract-code" class="col-sm-3 col-form-label">
                  Mã hợp đồng <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <input
                    id="contract-code"
                    v-model="formData.contractCode"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': validationErrors.contractCode }"
                  />
                  <div v-if="validationErrors.contractCode" class="invalid-feedback">
                    {{ validationErrors.contractCode }}
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="contract-files" class="col-sm-3 col-form-label"> File hợp đồng </label>
                <div class="col-sm-9">
                  <div class="custom-file mb-2">
                    <input
                      id="contract-files"
                      type="file"
                      class="custom-file-input"
                      @change="handleFilesUpload"
                      accept=".pdf"
                      multiple
                    />
                    <label class="custom-file-label" for="contract-files">
                      {{ fileLabel }}
                    </label>
                  </div>

                  <!-- Danh sách file đã chọn -->
                  <div
                    v-if="uploadFiles.length > 0"
                    class="contract-files-section upload-files-sectionmb-3 bg-light-subtle rounded-3"
                  >
                    <h6 class="file-section-title fw-bold mb-3" style="font-size: 12px">
                      Files sẽ upload
                    </h6>

                    <div class="upload-files-container">
                      <div
                        v-for="(file, index) in uploadFiles"
                        :key="index"
                        class="file-item mb-2 p-3 border border-dashed bg-white rounded-3 shadow-sm d-flex align-items-center justify-content-between"
                      >
                        <div class="d-flex align-items-center flex-grow-1">
                          <i
                            class="bx bxs-file-pdf text-danger file-icon me-3"
                            style="font-size: 32px"
                          ></i>

                          <div class="file-info overflow-hidden">
                            <div class="file-name text-truncate fw-medium">{{ file.name }}</div>
                            <div
                              class="file-status small mt-1"
                              :class="{
                                'text-primary': file.status === 'uploading',
                                'text-success': file.status === 'done',
                              }"
                            >
                              <span
                                v-if="file.status === 'uploading'"
                                class="d-flex align-items-center"
                              >
                                <i class="bx bx-loader-alt bx-spin me-1"></i>
                                Đang tải lên...
                              </span>
                              <span
                                v-else-if="file.status === 'done'"
                                class="d-flex align-items-center"
                              >
                                <i class="bx bx-check-circle me-1"></i>
                                Đã tải lên
                              </span>
                              <span v-else class="text-muted"> Chờ tải lên </span>
                            </div>
                          </div>
                        </div>

                        <div class="file-actions ms-2">
                          <button
                            type="button"
                            class="btn btn-sm btn-icon rounded-circle"
                            @click="removeFile(index)"
                            title="Xóa file"
                          >
                            <i class="bx bx-trash text-danger"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Danh sách files đã upload -->
                  <div
                    v-if="formData.contractFiles && formData.contractFiles.length > 0"
                    class="contract-files-section"
                  >
                    <h6 class="file-section-title fw-bold mb-3" style="font-size: 12px">
                      Files hợp đồng hiện tại
                    </h6>

                    <div class="contract-files-container">
                      <div
                        v-for="(file, index) in formData.contractFiles"
                        :key="'exist-' + index"
                        class="file-item mb-2 p-3 border rounded-3 shadow-sm d-flex align-items-center justify-content-between"
                      >
                        <div class="d-flex align-items-center">
                          <i
                            class="bx bxs-file-pdf text-danger file-icon me-3"
                            style="font-size: 32px"
                          ></i>

                          <div class="file-info">
                            <a
                              :href="file.link"
                              target="_blank"
                              class="file-link text-decoration-none fw-medium"
                            >
                              {{ file.name || `File hợp đồng ${index + 1}` }}
                            </a>
                            <div class="file-size text-muted small mt-1">PDF Document</div>
                          </div>
                        </div>

                        <div class="file-actions">
                          <button
                            type="button"
                            class="btn btn-sm btn-icon mr-2"
                            @click="previewFile(file)"
                            title="Xem file"
                          >
                            <i class="bx bx-show text-primary"></i>
                          </button>

                          <button
                            type="button"
                            class="btn btn-sm btn-icon"
                            @click="removeExistingFile(index)"
                            title="Xóa file"
                          >
                            <i class="bx bx-trash text-danger"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="invoice-receiver-name" class="col-sm-3 col-form-label">
                  Tên người nhận tt hóa đơn <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <input
                    id="invoice-receiver-name"
                    v-model="formData.nameReceiveNoticeInvoice"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': validationErrors.nameReceiveNoticeInvoice }"
                  />
                  <div v-if="validationErrors.nameReceiveNoticeInvoice" class="invalid-feedback">
                    {{ validationErrors.nameReceiveNoticeInvoice }}
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="invoice-receiver-email" class="col-sm-3 col-form-label">
                  Email nhận tt hóa đơn <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <input
                    id="invoice-receiver-email"
                    v-model="formData.emailReceiveNoticeInvoice"
                    type="text"
                    class="form-control"
                    placeholder="Nhập email, cho phép nhập nhiều email khi có dấu ,"
                    :class="{ 'is-invalid': validationErrors.emailReceiveNoticeInvoice }"
                  />
                  <div v-if="validationErrors.emailReceiveNoticeInvoice" class="invalid-feedback">
                    {{ validationErrors.emailReceiveNoticeInvoice }}
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="invoice-receiver-phone" class="col-sm-3 col-form-label">
                  SĐT nhận tt hóa đơn <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <input
                    id="invoice-receiver-phone"
                    v-model="formData.mobileReceiveNoticeInvoice"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': validationErrors.mobileReceiveNoticeInvoice }"
                  />
                  <div v-if="validationErrors.mobileReceiveNoticeInvoice" class="invalid-feedback">
                    {{ validationErrors.mobileReceiveNoticeInvoice }}
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="invoice-receive-method" class="col-sm-3 col-form-label">
                  Hình thức nhận hóa đơn <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <select
                    id="invoice-receive-method"
                    v-model="formData.typeReceiveNoticeInvoice"
                    class="form-control"
                    :class="{ 'is-invalid': validationErrors.typeReceiveNoticeInvoice }"
                  >
                    <option
                      v-for="(item, index) in Config.typeReceiveNoticeInvoice"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <div v-if="validationErrors.typeReceiveNoticeInvoice" class="invalid-feedback">
                    {{ validationErrors.typeReceiveNoticeInvoice }}
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="tax-code" class="col-sm-3 col-form-label">
                  Mã số thuế <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <input
                    id="tax-code"
                    v-model="formData.taxCode"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': validationErrors.taxCode }"
                  />
                  <div v-if="validationErrors.taxCode" class="invalid-feedback">
                    {{ validationErrors.taxCode }}
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="company-name" class="col-sm-3 col-form-label">
                  Tên công ty / cá nhân <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <input
                    id="company-name"
                    v-model="formData.companyName"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': validationErrors.companyName }"
                  />
                  <div v-if="validationErrors.companyName" class="invalid-feedback">
                    {{ validationErrors.companyName }}
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="company-address" class="col-sm-3 col-form-label">
                  Địa chỉ công ty / cá nhân <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <input
                    id="company-address"
                    v-model="formData.address"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': validationErrors.address }"
                  />
                  <div v-if="validationErrors.address" class="invalid-feedback">
                    {{ validationErrors.address }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-notification" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img
          :src="
            isSuccess
              ? require('@/assets/img/noti-success2.svg')
              : require('@/assets/img/noti-unsuccess2.svg')
          "
          :alt="isSuccess ? 'icon-success' : 'icon-error'"
        />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="handleCloseModal"> Đóng </b-button>
      </template>
    </b-modal>

    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import { AgentService } from '@/services/agent.service'
  import { CommonService } from '@/services/common.service'

  export default {
    data() {
      return {
        entryId: this.$route.params.id,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        Config,
        formData: {
          contractCode: '',
          contractFiles: [], // Thay thế linkContract bằng mảng các file
          nameReceiveNoticeInvoice: '',
          emailReceiveNoticeInvoice: '',
          mobileReceiveNoticeInvoice: '',
          typeReceiveNoticeInvoice: '',
          taxCode: '',
          companyName: '',
          address: '',
          verifyStatus: 'VERIFIED',
        },
        uploadFiles: [], // Mảng các file cần upload
        fileLabel: '(Chọn nhiều file PDF)',
        validationErrors: {
          contractCode: '',
          nameReceiveNoticeInvoice: '',
          emailReceiveNoticeInvoice: '',
          mobileReceiveNoticeInvoice: '',
          typeReceiveNoticeInvoice: '',
          taxCode: '',
          companyName: '',
          address: '',
        },
        notiModal: false,
        msgNoti: '',
        isSuccess: true,
      }
    },

    created() {
      // Mặc định giá trị cho typeReceiveNoticeInvoice nếu có cấu hình
      if (this.Config.typeReceiveNoticeInvoice && this.Config.typeReceiveNoticeInvoice.length > 0) {
        this.formData.typeReceiveNoticeInvoice = this.Config.typeReceiveNoticeInvoice[0].id
      }

      this.fetchData()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      previewFile(file) {
        if (file) {
          window.open(file, '_blank')
        }
      },
      async fetchData() {
        try {
          this.loading = true
          const res = await AgentService.getDetailAgentPartner(this.entryId)
          if (res.code === 1000 && res.data) {
            const data = res.data.verifyAgentBankInfo || {}

            // Mặc định cho typeReceiveNoticeInvoice nếu không có giá trị
            const defaultType =
              this.Config.typeReceiveNoticeInvoice &&
              this.Config.typeReceiveNoticeInvoice.length > 0
                ? this.Config.typeReceiveNoticeInvoice[0].id
                : ''

            // Parse linkContract thành mảng contractFiles nếu cần
            let contractFiles = []
            if (data.linkContract) {
              if (typeof data.linkContract === 'string') {
                // Nếu là string đơn, tạo một mảng với một phần tử
                contractFiles = [{ link: data.linkContract, name: 'Hợp đồng' }]
              } else if (Array.isArray(data.linkContract)) {
                // Nếu đã là mảng, sử dụng trực tiếp
                contractFiles = data.linkContract.filter(item => item !== null)
              }
            }

            this.formData = {
              contractCode: data.contractCode || '',
              contractFiles: contractFiles,
              nameReceiveNoticeInvoice: data.nameReceiveNoticeInvoice || '',
              emailReceiveNoticeInvoice: data.emailReceiveNoticeInvoice || '',
              mobileReceiveNoticeInvoice: data.mobileReceiveNoticeInvoice || '',
              typeReceiveNoticeInvoice:
                data.typeReceiveNoticeInvoice || data.invoiceReceiveMethod || defaultType,
              taxCode: data.taxCode || '',
              companyName: data.name || data.companyName || '',
              address: data.address || '',
              verifyStatus: data.verifyStatus || 'VERIFIED',
            }
          }
        } catch (error) {
          console.log(error)
          this.showErrorModal('Không thể tải dữ liệu, vui lòng thử lại sau')
        } finally {
          this.loading = false
        }
      },

      handleFilesUpload(event) {
        const files = event.target.files
        if (files && files.length > 0) {
          // Kiểm tra từng file có phải PDF không
          let allPdf = true
          for (let i = 0; i < files.length; i++) {
            if (files[i].type !== 'application/pdf') {
              allPdf = false
              break
            }
          }

          if (!allPdf) {
            this.showErrorModal('Chỉ chấp nhận file PDF')
            event.target.value = ''
            this.fileLabel = '(Chọn nhiều file PDF)'
            return
          }

          // Thêm files vào mảng uploadFiles
          for (let i = 0; i < files.length; i++) {
            this.uploadFiles.push({
              file: files[i],
              name: files[i].name,
              status: 'pending',
            })
          }

          // Cập nhật label
          this.fileLabel = `${this.uploadFiles.length} file được chọn`
        } else {
          this.fileLabel = '(Chọn nhiều file PDF)'
        }

        // Reset input để có thể chọn lại file đã chọn trước đó
        event.target.value = ''
      },

      removeFile(index) {
        this.uploadFiles.splice(index, 1)
        this.fileLabel =
          this.uploadFiles.length > 0
            ? `${this.uploadFiles.length} file được chọn`
            : '(Chọn nhiều file PDF)'
      },

      removeExistingFile(index) {
        this.formData.contractFiles.splice(index, 1)
      },

      // Upload file lên S3
      async uploadFileToS3(fileItem) {
        try {
          const formData = new FormData()
          formData.append('files', fileItem.file)
          formData.append('folderName', 'NextCrm')

          const response = await CommonService.uploadFile(formData)
          if (response && response.data && response.data.length > 0) {
            fileItem.status = 'uploaded'
            return response.data[0]
          }
          return null
        } catch (error) {
          console.error('Upload file error:', error)
          return null
        }
      },

      // Upload tất cả các file
      async uploadAllFiles() {
        const uploadedFiles = []

        // Upload từng file và lưu kết quả
        for (let i = 0; i < this.uploadFiles.length; i++) {
          this.uploadFiles[i].status = 'uploading'
          const result = await this.uploadFileToS3(this.uploadFiles[i])
          if (result) {
            uploadedFiles.push({
              link: result,
              name: this.uploadFiles[i].name,
            })
          } else {
            this.showErrorModal(`Không thể tải lên file: ${this.uploadFiles[i].name}`)
            return null
          }
        }

        return uploadedFiles
      },

      validateForm() {
        let isValid = true

        // Reset all validation errors
        Object.keys(this.validationErrors).forEach(key => {
          this.validationErrors[key] = ''
        })

        // Validate each field
        if (!this.formData.contractCode.trim()) {
          this.validationErrors.contractCode = 'Vui lòng nhập mã hợp đồng'
          isValid = false
        }

        if (!this.formData.nameReceiveNoticeInvoice.trim()) {
          this.validationErrors.nameReceiveNoticeInvoice =
            'Vui lòng nhập tên người nhận thông tin hóa đơn'
          isValid = false
        }

        if (!this.formData.emailReceiveNoticeInvoice.trim()) {
          this.validationErrors.emailReceiveNoticeInvoice =
            'Vui lòng nhập email nhận thông tin hóa đơn'
          isValid = false
        }

        if (!this.formData.mobileReceiveNoticeInvoice.trim()) {
          this.validationErrors.mobileReceiveNoticeInvoice =
            'Vui lòng nhập số điện thoại nhận thông tin hóa đơn'
          isValid = false
        }

        if (!this.formData.typeReceiveNoticeInvoice) {
          this.validationErrors.typeReceiveNoticeInvoice = 'Vui lòng chọn hình thức nhận hóa đơn'
          isValid = false
        }

        if (!this.formData.taxCode.trim()) {
          this.validationErrors.taxCode = 'Vui lòng nhập mã số thuế'
          isValid = false
        }

        if (!this.formData.companyName.trim()) {
          this.validationErrors.companyName = 'Vui lòng nhập tên công ty/cá nhân'
          isValid = false
        }

        if (!this.formData.address.trim()) {
          this.validationErrors.address = 'Vui lòng nhập địa chỉ công ty/cá nhân'
          isValid = false
        }

        return isValid
      },

      async saveData() {
        // Validate form
        if (!this.validateForm()) {
          this.showErrorModal('Vui lòng điền đầy đủ thông tin')
          return
        }

        try {
          this.loading = true

          // Upload tất cả file mới nếu có
          let uploadedFiles = null
          if (this.uploadFiles.length > 0) {
            uploadedFiles = await this.uploadAllFiles()
            if (!uploadedFiles) {
              this.loading = false
              return
            }
          }

          // Tạo payload theo cấu trúc API yêu cầu
          const payload = {
            id: this.entryId,
            address: this.formData.address,
            contractCode: this.formData.contractCode,
            emailReceiveNoticeInvoice: this.formData.emailReceiveNoticeInvoice,
            name: this.formData.companyName,
            nameReceiveNoticeInvoice: this.formData.nameReceiveNoticeInvoice,
            taxCode: this.formData.taxCode,
            typeReceiveNoticeInvoice: this.formData.typeReceiveNoticeInvoice,
            verifyStatus: this.formData.verifyStatus,
            mobileReceiveNoticeInvoice: this.formData.mobileReceiveNoticeInvoice,
          }

          // Kết hợp files hiện tại và files mới upload
          const allFiles = [...this.formData.contractFiles]
          if (uploadedFiles && uploadedFiles.length > 0) {
            allFiles.push(...uploadedFiles)
          }

          // Nếu có files, tạo trường linkContract
          if (allFiles.length > 0) {
            // Xử lý mảng để lấy các link
            const processedLinks = allFiles.map(file => {
              // Nếu file là string, giữ nguyên
              if (typeof file === 'string') {
                return file
              }
              // Nếu file là object có thuộc tính link, lấy link
              else if (file && file.link) {
                return file.link
              }
              // Trường hợp khác (null, undefined) trả về chuỗi rỗng
              return ''
            })

            // Lọc bỏ các chuỗi rỗng nếu cần
            // const filteredLinks = processedLinks.filter(link => link.trim() !== '');

            // Nếu có nhiều file, dùng mảng
            payload.linkContract = processedLinks
          }

          // Gọi API cập nhật thông tin
          const response = await AgentService.updateAgentPartner(payload)

          if (response.code === 1000) {
            this.showSuccessModal('Cập nhật thông tin thành công')

            // Xóa mảng file đã upload
            this.uploadFiles = []
            this.fileLabel = '(Chọn nhiều file PDF)'
          } else {
            this.showErrorModal(response.message || 'Có lỗi xảy ra, vui lòng thử lại sau')
          }
        } catch (error) {
          console.log(error)
          this.showErrorModal('Có lỗi xảy ra, vui lòng thử lại sau')
        } finally {
          this.loading = false
        }
      },

      showSuccessModal(message) {
        this.isSuccess = true
        this.msgNoti = message
        this.notiModal = true
      },

      showErrorModal(message) {
        this.isSuccess = false
        this.msgNoti = message
        this.notiModal = true
      },

      handleCloseModal() {
        this.notiModal = false
        // Nếu thành công, quay về trang chi tiết
        if (this.isSuccess) {
          this.$router.push(`/list-agent-partner-detail/${this.entryId}`)
        }
      },
    },
  }
</script>

<style scoped>
  .card {
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }

  .breadcrumb-area {
    margin-bottom: 20px;
  }

  .breadcrumb-area h1 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 0;
  }

  .btn-group .btn {
    margin-left: 5px;
  }

  .custom-file-label::after {
    content: 'Chọn file';
  }

  .text-danger {
    color: #dc3545 !important;
  }

  .invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
  }

  .is-invalid {
    border-color: #dc3545;
  }

  .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
  }

  .btn-danger {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
  }
</style>
